import { render, staticRenderFns } from "./QuickemailMyPage.vue?vue&type=template&id=0f681dfe&scoped=true&"
import script from "./QuickemailMyPage.vue?vue&type=script&lang=js&"
export * from "./QuickemailMyPage.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/renew2_mypage.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f681dfe",
  null
  
)

export default component.exports